var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlarmFilled = function SvgAlarmFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.542 14.8-.95-2.025a1.86 1.86 0 0 1-.175-.792V8.692c0-2.8-2.117-5.175-4.792-5.492V2.108A.63.63 0 0 0 10 1.483a.63.63 0 0 0-.625.625v1.1a5.299 5.299 0 0 0-3.133 1.475 5.388 5.388 0 0 0-1.659 3.9v3.4c0 .275-.058.542-.175.792l-.95 2.033c-.15.325-.125.7.067 1 .192.3.517.484.875.484h2.933a2.71 2.71 0 0 0 2.659 2.241 2.703 2.703 0 0 0 2.658-2.241h2.933c.359 0 .684-.184.875-.484.192-.3.217-.675.067-1l.017-.008ZM10 17.275a1.458 1.458 0 0 1-1.375-.992h2.75c-.2.575-.733.992-1.375.992Z",
    fill: "current"
  })));
};
export default SvgAlarmFilled;